export { default as Slider} from './Slider'
export { default as Features} from './Features'
export { default as RequestRates} from './RequestRates'
export { default as About} from './About'